{
  "removeButtonLabel": "Ukloni",
  "removeDescription": "Pritisnite Delete za uklanjanje oznake."
}
